module.exports = __webpack_public_path__ + "static/media/house7.35abc311.png";